import { type DimensionValue, Image, type ImageProps } from 'react-native';
import React from 'react';

const NetworkImageView: React.FC<
  ImageProps & { style: { width?: DimensionValue; height?: DimensionValue } }
> = props => {
  return <Image {...props} />;
};
export default NetworkImageView;
